import React from "react"
import styles from "@/styles/CTA.module.scss"
import CustomLink from "./CustomLink"
import { CTAProps } from "@/app/interface/components"

const CTA: React.FC<CTAProps> = ({ flexDirection="row", text, href }) => {
    return (
        <div className={styles.main}>
            <div style={{flexDirection: flexDirection}}>
                <span>{text}</span>
                <CustomLink href={href} className="btn-secondary">Solicite contato</CustomLink>
            </div>
        </div>
    )
}

export default React.memo(CTA)
